var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-accounting"},[_c('accounting-navigation'),_c('commissions',{attrs:{"activityTagName":"account management"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }